export const getOffersApiConfig = {
  mode: 'app',
  version: 'v1',
};

export const topDestinationsApiConfig = {
  version: 'v1',
};

export const brandPromisesApiConfig = {
  version: 'v1',
};

export const smartEngageApiConfig = {
  version: 'v1',
  status: 'LIVE',
  homePageLanding: {
    context: 'gnr',
    slots: ['mp_hotel_home1', 'mp_hotel_home2'],
    sendNodeId: true,
  },
  homePageLandingWithCityId: {
    context: 'gnr',
    slots: ['mp_hotel_home1', 'mp_hotel_home2'],
    sendNodeId: true,
  },
  srpLanding: {
    /*
    mp_hotel_srp3 is for the offer banner
    hotels_home context is used to derive content customised for mypartner
    */
    context: 'hotels_home',
    slots: ['mp_hotel_srp1', 'mp_hotel_srp2', 'mp_hotel_srp3'],
    sendNodeId: true,
  },
  detailsLanding: {
    context: 'gnr',
    slots: ['mp_hotel_details1'],
    sendNodeId: true,
  },
};

// export const smartEngageApiConfig = {
//   version: 'v1',
//   context: 'hotels_srp',
//   status: 'LIVE',
//   slots: [
//     'dweb_ih_banner_v2',
//     'dwebHotels_info_srp',
//     'dwebHotels_banner_srp'
//   ],
// };

export const hermesSrpApiConfig = {
  version: 'v12',
};

export const agentHermesSrpApiConfig = {
  version: 'v12',
};

export const hermesSrpOfferApiConfig = {
  version: 'v10.5',
};

export const detailsHermesConfig = {
  version: 'v12',
};

export const hermesSegmentSliderApiConfig = {
  version: 'v12',
};

export const hermesDealsPageApiConfig = {
  version: 'v11',
};

// change this back before deployment
export const __HERMES__ = __ENV_CONFIG__.HERMES;
export const __MYPARTNER__ = __ENV_CONFIG__.MYPARTNER;
export const __VOYAGER__ = __ENV_CONFIG__.VOYAGER;
export const __VOYAGERX__ = __ENV_CONFIG__.VOYAGERX;
export const __GOIBIBO__ = __ENV_CONFIG__.GOIBIBO;
export const __DEXTER__ = __ENV_CONFIG__.DEXTER;

// Server to server call config
export const __MYPARTNER_SERVER_CALL__ = __ENV_CONFIG__.MYPARTNER_SERVER;

export const __latLongToVcid__ = '/api/v1/hotels/nearby_hotel_city/';

export const detailsAPIEndPoints = {
  hermes: `hotels/${detailsHermesConfig.version}/detail/price/v3`,
  cancellationPolicy: `hotel/getCancelPolicyDataNew`,
  hotelPolicy: `hotel/getHotelPolicyDataV2/?flavour=v3&tag=All`,
  similarHotels({cityId, checkin, checkout, hyphenatedPax, queryString}) {
    return `${__HERMES__}/hotels/v12/suggest/data/v3/${cityId}/${checkin}/${checkout}/${hyphenatedPax}/${queryString}`;
  },
};

export const noCostEMIMarketingLink = `${__GOIBIBO__}/offers/no-cost-emi/`;
